module.exports = __webpack_public_path__ + "static/img/show_pic6.0bb18bf2.png";